/**
 * 新闻主体的内容，样式来源于情报
 */

import React from 'react';
import { NewsItemType } from './index';

export default function NewsContent(props: NewsItemType) {
  const { titleEn, newsType, postedOn, news } = props;

  return (
    <div>
      <div className="dbg-details-overview-news-modal">
        <div className="dbg-details-overview-news-modal-title">{titleEn}</div>
        <div className="dbg-details-overview-news-modal-flex">
          <div className="text-time">{postedOn}</div>
          <div className="text-desc">{newsType}</div>
        </div>
      </div>
      <div className="dbg-details-overview-news-modal-context">{news}</div>
    </div>
  )
}